import { render, staticRenderFns } from "./MixAndMatch.vue?vue&type=template&id=773bd5c4"
import script from "./MixAndMatch.vue?vue&type=script&lang=js"
export * from "./MixAndMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports